module.exports = __webpack_public_path__ + "media/images/default_community_image_header-b8fc58eefefd5e1168e7b464c5116a58.png";